class Store {
  constructor() {
    this._navPages = [];
    this._siteSettings = null;
    this._listeners = new Set();
  }

  setNavPages(pages) {
    this._navPages = pages.filter(p => p.is_published && !p.is_deleted);
    this._notify();
  }

  getNavPages() {
    return this._navPages;
  }

  setSiteSettings(settings) {
    this._siteSettings = settings;
    this._notify();
  }

  getSiteSettings() {
    return this._siteSettings;
  }

  subscribe(fn) {
    this._listeners.add(fn);
    return () => this._listeners.delete(fn);
  }

  _notify() {
    for (const fn of this._listeners) fn();
  }
}

export const store = new Store();
